import { countryFlagUrl } from '../countries';

export function Flag({ code, lazy }: { code: string; lazy?: boolean }) {
  const url = countryFlagUrl(code);
  if (!url) return null;
  return <img className="flag" src={url} alt="" loading={lazy ? 'lazy' : undefined} />;
}
